import { getFramework } from '@/framework';
import { getRulerState } from '@/plugins/ruler-bar/states/ruler-state';
import { RULER_BAR_EVENTS, RULER_BAR_SIZE } from '@/version-types';

export function setShowRulerBar(identity: string, show: boolean) {
    const framework = getFramework(identity);
    const setShowRulerBar = getRulerState(identity).setShowRulerBar;
    const viewPortPadding = framework.stage.getViewPortPadding();
    setShowRulerBar(show);
    framework.events.emit(RULER_BAR_EVENTS.ON_SHOW_CHANGED, show);

    // 现在是隐藏, 需要显示
    if (show) {
        framework.stage.setViewPortPadding(viewPortPadding + RULER_BAR_SIZE);
    }
    // 现在是现显示, 需要隐藏
    else {
        framework.stage.setViewPortPadding(viewPortPadding - RULER_BAR_SIZE);
    }
}
